import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "mb-2 text-body-2" }, "System groups are available to all accounts. ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "mb-2 text-body-2" }, " Name the group, and optionally assign applications. Applications can be removed from a group at any time. ", -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "mb-2 text-body-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_stepper_item = _resolveComponent("v-stepper-item")!
  const _component_v_stepper_header = _resolveComponent("v-stepper-header")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_stepper_window_item = _resolveComponent("v-stepper-window-item")!
  const _component_AssignApplications = _resolveComponent("AssignApplications")!
  const _component_AssignUsers = _resolveComponent("AssignUsers")!
  const _component_v_stepper_window = _resolveComponent("v-stepper-window")!
  const _component_v_stepper = _resolveComponent("v-stepper")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    width: "500",
    onAfterLeave: _cache[7] || (_cache[7] = ($event: any) => {_ctx.step = 1; _ctx.resetDialog(); _ctx.group.name = '';})
  }, {
    activator: _withCtx(({ props }) => [
      _createVNode(_component_v_btn, _mergeProps(props, {
        size: "small",
        variant: "plain",
        color: "primary"
      }), {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.mdAndUp && _ctx.system ? 'Add system group' : _ctx.mdAndUp && !_ctx.system ? 'Add user group' : 'Add'), 1)
        ]),
        _: 2
      }, 1040)
    ]),
    default: _withCtx(({ isActive }) => [
      _createVNode(_component_v_card, {
        title: _ctx.system ? 'Add and configure a system group' : 'Add and configure a user group'
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                (_ctx.system)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
                  : (_openBlock(), _createElementBlock("p", _hoisted_5, " Name the group, and optionally assign applications, users, or both. Applications and users can be removed from a group at any time. "))
              ]),
              _createVNode(_component_v_stepper, {
                elevation: "0",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.step = $event)),
                "model-value": _ctx.step,
                class: "ma-0 add-group"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_stepper_header, {
                    style: {"box-shadow":"none"},
                    class: "mb-4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_stepper_item, {
                        color: "primary",
                        ripple: false,
                        title: "Group",
                        value: 1,
                        icon: "mdi-pencil",
                        editable: "",
                        complete: _ctx.step > 1
                      }, null, 8, ["complete"]),
                      _createVNode(_component_v_stepper_item, {
                        disabled: _ctx.disabled,
                        color: "primary",
                        ripple: false,
                        title: "Applications",
                        "edit-icon": "mdi-application",
                        editable: "",
                        value: 2
                      }, null, 8, ["disabled"]),
                      (!_ctx.system)
                        ? (_openBlock(), _createBlock(_component_v_stepper_item, {
                            key: 0,
                            disabled: _ctx.disabled,
                            color: "primary",
                            ripple: false,
                            title: "Users",
                            "edit-icon": "mdi-account-multiple",
                            value: 3,
                            editable: ""
                          }, null, 8, ["disabled"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_stepper_window, {
                    "model-value": _ctx.step,
                    class: "ma-0"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_stepper_window_item, {
                        value: 1,
                        class: "ma-0"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_form, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_row, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { cols: "12" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_text_field, {
                                        density: "compact",
                                        label: "Group name",
                                        modelValue: _ctx.group.name,
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.group.name) = $event)),
                                        rules: [_ctx.validateUniqueName]
                                      }, null, 8, ["modelValue", "rules"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_stepper_window_item, {
                        value: 2,
                        class: "ma-0"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_AssignApplications, {
                            currentGroup: _ctx.group,
                            onUpdateAppsToAdd: _cache[1] || (_cache[1] = ($event: any) => (_ctx.appsToAdd = $event)),
                            removeApplicationAccessFromGroup: _ctx.removeApplicationAccessFromGroup
                          }, null, 8, ["currentGroup", "removeApplicationAccessFromGroup"])
                        ]),
                        _: 1
                      }),
                      (!_ctx.system)
                        ? (_openBlock(), _createBlock(_component_v_stepper_window_item, {
                            key: 0,
                            value: 3,
                            class: "ma-0"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_AssignUsers, {
                                currentGroup: _ctx.group,
                                onUpdateUsersToAdd: _cache[2] || (_cache[2] = ($event: any) => (_ctx.usersToAdd = $event)),
                                removeUserFromGroup: _ctx.removeUserFromGroup
                              }, null, 8, ["currentGroup", "removeUserFromGroup"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["model-value"])
                ]),
                _: 1
              }, 8, ["model-value"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [
              (_ctx.step === 1)
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 0,
                    color: "grey",
                    onClick: ($event: any) => {isActive.value = false; _ctx.resetDialog()}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Cancel ")
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (_ctx.step > 1)
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 1,
                    color: "grey",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.step--))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, { start: "" }, {
                        default: _withCtx(() => [
                          _createTextVNode("mdi-chevron-left")
                        ]),
                        _: 1
                      }),
                      _createTextVNode(" Back ")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_v_spacer),
              (_ctx.step === 1)
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 2,
                    loading: _ctx.loading,
                    disabled: _ctx.disabled,
                    color: "secondary",
                    onClick: ($event: any) => {_ctx.createGroup(); isActive.value = false}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Create group ")
                    ]),
                    _: 2
                  }, 1032, ["loading", "disabled", "onClick"]))
                : _createCommentVNode("", true),
              (_ctx.step === 2 && _ctx.system)
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 3,
                    loading: _ctx.loading,
                    disabled: _ctx.disabled || !_ctx.appsToAdd.length,
                    color: "primary",
                    onClick: ($event: any) => {_ctx.createGroupWithApplicationsAndUsers(); isActive.value = false}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Create group ")
                    ]),
                    _: 2
                  }, 1032, ["loading", "disabled", "onClick"]))
                : _createCommentVNode("", true),
              (_ctx.step === 1)
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 4,
                    disabled: _ctx.disabled,
                    color: "primary",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.step++))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Next "),
                      _createVNode(_component_v_icon, { end: "" }, {
                        default: _withCtx(() => [
                          _createTextVNode("mdi-chevron-right")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["disabled"]))
                : _createCommentVNode("", true),
              (_ctx.step === 2 && !_ctx.system)
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 5,
                    disabled: _ctx.disabled || !_ctx.appsToAdd.length,
                    color: "secondary",
                    onClick: ($event: any) => {_ctx.createGroupWithApplicationsAndUsers(); isActive.value = false}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Create group ")
                    ]),
                    _: 2
                  }, 1032, ["disabled", "onClick"]))
                : _createCommentVNode("", true),
              (_ctx.step === 2 && !_ctx.system)
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 6,
                    disabled: _ctx.disabled,
                    color: "primary",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.step++))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.appsToAdd.length ? 'Next' : 'Skip') + " ", 1),
                      _createVNode(_component_v_icon, { end: "" }, {
                        default: _withCtx(() => [
                          _createTextVNode("mdi-chevron-right")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["disabled"]))
                : _createCommentVNode("", true),
              (_ctx.step === 3)
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 7,
                    disabled: _ctx.disabled || !_ctx.usersToAdd.length,
                    color: "primary",
                    onClick: ($event: any) => {_ctx.createGroupWithApplicationsAndUsers(); isActive.value = false;}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Create group ")
                    ]),
                    _: 2
                  }, 1032, ["disabled", "onClick"]))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1024)
        ]),
        _: 2
      }, 1032, ["title"])
    ]),
    _: 1
  }))
}